var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceMaybe(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87348 15.1265C3.51384 13.7669 2.75 11.9228 2.75 10C2.75 8.07718 3.51384 6.23311 4.87348 4.87348C6.23311 3.51384 8.07718 2.75 10 2.75C11.9228 2.75 13.7669 3.51384 15.1265 4.87348C16.4862 6.23311 17.25 8.07718 17.25 10C17.25 11.9228 16.4862 13.7669 15.1265 15.1265C13.7669 16.4862 11.9228 17.25 10 17.25C8.07718 17.25 6.23311 16.4862 4.87348 15.1265Z",
    fill: "#FEB11F",
    stroke: "#FEB11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2102 8L9.77319 11.9996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77165 11.9999L8 9.93823",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceMaybe);
export default __webpack_public_path__ + "static/media/compliance-maybe.ba5828a0.svg";
export { ForwardRef as ReactComponent };